import { styleOverrides } from "./styleOverrides";
import { defaultProps } from "./defaultProps";

const MuiPaginationItem = {
  styleOverrides,
  defaultProps,
};

export { MuiPaginationItem };
